import {Container, Singleton} from 'typescript-ioc'
import BaseApi from '@/api/BaseApi'
import Paging from "biz-ts/src/api/Paging";
import {DtaskGenPqForm} from "@/form/DeviceTaskForm";
import DeviceTaskGenerator from "@/model/DeviceTaskGenerator";

export class DtaskEnableForm {
    id!: number
    enabled!: boolean
}

@Singleton
export default abstract class DeviceTaskGenApi {

    abstract paging(form: DtaskGenPqForm): Promise<Paging<DeviceTaskGenerator>>

    abstract enable(form: DtaskEnableForm): Promise<void>

    abstract delete(id: number): Promise<void>
}

class DeviceTaskGenApiImpl extends BaseApi implements DeviceTaskGenApi {

    protected urlPrefix = 'device/task/generator'

    paging(form: DtaskGenPqForm): Promise<Paging<DeviceTaskGenerator>> {
        return this.axios.get('paging', {params: form})
    }

    enable(form: DtaskEnableForm): Promise<void> {
        return this.axios.post('enable', form)
    }

    delete(id: number): Promise<void> {
        return this.axios.get('delete', {params: {id: id}})
    }
}

Container.bind(DeviceTaskGenApi).to(DeviceTaskGenApiImpl)
